module.exports = __webpack_public_path__ + "img/step-1.a32c4193.png";